export const SET_ERROR = "SET_ERROR";
export const POST_ERROR = "POST_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";